import React from "react";
import { useAuth } from "../auth/AuthContext";

export default function ShopSwitcher() {
  const { shops, activeShop, setActiveShopId } = useAuth();

  if (shops.length === 0) {
    return null;
  }

  if (shops.length === 1) {
    return <div className="chip">{shops[0].shop_name}</div>;
  }

  return (
    <select
      className="shop-switcher"
      value={activeShop?.shop_id ?? ""}
      onChange={(e) => setActiveShopId(Number(e.target.value))}
      aria-label="Active shop"
    >
      {shops.map((s) => (
        <option key={s.shop_id} value={s.shop_id}>
          {s.shop_name}
        </option>
      ))}
    </select>
  );
}
